import {
  Autocomplete,
  FormControl,
  Grid,
  InputLabel,
  TextField
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import type { RegionSelectorProps } from './RegionSelector.types';

/**
 * RegionSelector renders a multi-select for choosing regions (e.g., us-east-1, us-west-2).
 * Used by AWS sources to specify which regions to monitor.
 */
const RegionSelector = ({
  connectionInputSchema,
  regions,
  onRegionChange,
  isResettingSourceType,
  className
}: RegionSelectorProps) => {
  const { control, formState } = useFormContext();
  const { errors } = formState;

  if (isResettingSourceType) return null;
  if (
    !connectionInputSchema?.show_regions &&
    !connectionInputSchema?.region_inputs
  )
    return null;

  const options = connectionInputSchema?.region_inputs?.[0]?.options ?? [];
  const hasError = Boolean(errors?.region);
  const errorMessage = errors?.region?.message as string;

  const renderRegionOption = (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: string
  ) => <li {...props}>{option}</li>;

  return (
    <Grid size={{ xs: 12, sm: 12, md: 8 }}>
      <InputLabel htmlFor="device-name-input">
        Region <span> *</span>
      </InputLabel>
      <FormControl fullWidth>
        <Controller
          control={control}
          name="region"
          rules={{
            required: 'Select Region'
          }}
          render={({ field: { onChange } }) => (
            <Autocomplete
              className={className}
              multiple
              limitTags={3}
              defaultValue={regions || []}
              options={options.map((option) => option)}
              getOptionLabel={(option) => option || ''}
              disableCloseOnSelect
              value={regions || []}
              onChange={(_event, newValue) => {
                onChange(newValue || null);
                onRegionChange(newValue);
              }}
              renderOption={(props, option) =>
                renderRegionOption(props, option)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={hasError}
                  helperText={errorMessage}
                />
              )}
            />
          )}
        />
      </FormControl>
    </Grid>
  );
};

export default RegionSelector;
